import {
  wixCliAction,
  wixCliAppFlowStepsAnswers,
} from '@wix/bi-logger-dev-tools-data/v2';
import type { BiLogger } from '@wix/cli-telemetry';

export const createAppBiEvents = (biLogger: BiLogger) => ({
  cliAction: ({
    question,
    questionKey,
    action,
    key,
    additionalInfo,
  }: {
    question: string;
    questionKey: string;
    action: string;
    key: string;
    additionalInfo?: Record<string, unknown>;
  }) => {
    void biLogger.report(
      wixCliAction({
        action,
        key,
        question,
        questionKey,
        additionalInfo: JSON.stringify(additionalInfo),
      })
    );
  },
  cliFlowStepAnswered: ({
    question,
    questionKey,
    answer,
    additionalInfo,
  }: {
    question: string;
    questionKey: string;
    answer: string;
    additionalInfo?: Record<string, unknown>;
  }) => {
    void biLogger.report(
      wixCliAppFlowStepsAnswers({
        answer,
        question,
        questionKey,
        additionalInfo: JSON.stringify(additionalInfo),
      })
    );
  },
});
